import { Language, getDefaultLanguage, getLanguages } from '@rbilabs/intl';

import { SupportedRegions } from '@rbi-ctg/frontend';
import { PROD_SUPPORTED_REGIONS } from 'state/intl/hook';
import { REGIONS } from 'state/intl/types';
import { brand } from 'utils/environment';

export const determineValidLang = (region: REGIONS | string, browserLang: Language) => {
  const regionSupportedLanguages = getLanguages(brand(), region);
  // Pull supported Languages for region / brand.
  const regionSupportsBrowserLang = regionSupportedLanguages.includes(browserLang);
  // Use user language if supported by region otherwise use default language
  return regionSupportsBrowserLang ? browserLang : getDefaultLanguage(brand(), region);
};

export const isSupportedRegion = (
  region: SupportedRegions | string
): region is SupportedRegions => {
  return PROD_SUPPORTED_REGIONS[region];
};

export const isNewLocaleSameAsCurrent = (
  currentLocale: string,
  region: SupportedRegions,
  lang: string
) => {
  const determinedLocale = `${lang}-${region}`;
  return determinedLocale === currentLocale;
};
